import React, { useState } from 'react';
import { InventoryProvider } from './context/InventoryContext';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import Products from './components/Products';
import Transactions from './components/Transactions';
import Warehouses from './components/Warehouses';

export default function App() {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <InventoryProvider>
      <Layout activeTab={activeTab} setActiveTab={setActiveTab}>
        {activeTab === 'dashboard' && <Dashboard />}
        {activeTab === 'transactions' && <Transactions />}
        {activeTab === 'products' && <Products />}
        {activeTab === 'warehouses' && <Warehouses />}
      </Layout>
    </InventoryProvider>
  );
}
